import { Helmet } from "react-helmet-async";
import {
  breadcrumbsFromPath,
  breadcrumbSchema,
  faqSchema,
  organizationSchema,
  websiteSchema,
  type BreadcrumbItem,
  type FaqItem,
} from "@/lib/structuredData";

type SeoProps = {
  title: string;
  description: string;
  path?: string;
  /** Optional FAQ pairs, rendered as FAQPage JSON-LD */
  faqs?: FaqItem[];
  /** Optional explicit breadcrumb trail; defaults to one derived from `path` */
  breadcrumbs?: BreadcrumbItem[];
};

const SITE = "https://yootelco.com";

export default function Seo({ title, description, path = "", faqs, breadcrumbs }: SeoProps) {
  const url = `${SITE}${path}`;
  const trail = breadcrumbs ?? breadcrumbsFromPath(path);
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      {path === "/" && (
        <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      )}
      {trail.length > 1 && (
        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema(trail))}</script>
      )}
      {faqs && faqs.length > 0 && (
        <script type="application/ld+json">{JSON.stringify(faqSchema(faqs))}</script>
      )}
    </Helmet>
  );
}
